import {createSelector} from 'reselect';

import {getDateTime} from '@/libs/dateHelper';
import {getZone} from '@/libs/timezoneHelper';

export const getTimeZoneStore = (state) => state.timeZoneStore;

export const getIsAutoSync = createSelector([getTimeZoneStore], (timeZoneStore) => timeZoneStore.isAutoSync);
export const getGeoArea = createSelector([getTimeZoneStore], (timeZoneStore) => timeZoneStore.geoArea);
export const getRegion = createSelector([getTimeZoneStore], (timeZoneStore) => timeZoneStore.region);
export const getDate = createSelector([getTimeZoneStore], (timeZoneStore) => timeZoneStore.date);
export const getTime = createSelector([getTimeZoneStore], (timeZoneStore) => timeZoneStore.time);
export const getOrigin = createSelector([getTimeZoneStore], (timeZoneStore) => timeZoneStore.origin);

export const getDeviceSettingDateTime = createSelector(
  [getIsAutoSync, getGeoArea, getRegion, getDate, getTime],
  (isAutoSync, geoArea, region, date, time) => ({
    isAutoSync,
    timeZone: getZone(geoArea, region).replace('/', ' - '),
    date, // new Date(dateTime).toLocaleDateString('en-US'),
    time, // new Date(dateTime).toLocaleString('en-US', {hour: 'numeric', minute: 'numeric', hour12: true}),
    dateTime: getDateTime(date, time),
  }),
);

export const disabledSaveTimezoneSetting = createSelector(
  [
    getOrigin,
    (state, {selectedArea, selectedRegion}) => ({
      selectedArea,
      selectedRegion,
    }),
  ],
  (origin, {selectedArea, selectedRegion}) => origin?.geoArea === selectedArea && origin?.region === selectedRegion,
);

export const getTimezoneState = createSelector(
  [getIsAutoSync, getGeoArea, getRegion, getDate, getTime, getOrigin],
  (isAutoSync, geoArea, region, date, time, origin) => ({
    isAutoSync,
    isAutoSyncOrigin: origin?.isAutoSync,
    geoArea,
    geoAreaOrigin: origin?.geoArea,
    region,
    regionOrigin: origin?.region,
    date,
    dateOrigin: origin?.date,
    time,
    timeOrigin: origin?.time,
  }),
);
